import { ChemicalTemplateItemRequest } from '../request-models/chemical-template-item-request.model';
import { ChemicalTemplateRequest } from '../request-models/chemical-template-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * The hub request body for creating or updating a chemical template. Copies only the allowlisted fields (and
 * item fields) and drops the ones that are not set, so an update stays partial; `null` (clear the field) is kept.
 */
export function toChemicalTemplateRequest(fields: ChemicalTemplateRequest): ChemicalTemplateRequest {
  return omitUndefined<ChemicalTemplateRequest>({
    name: fields.name,
    description: fields.description,
    targetCrops: fields.targetCrops,
    targetPests: fields.targetPests,
    applicationTiming: fields.applicationTiming,
    totalVolume: fields.totalVolume,
    estimatedCostPerAcre: fields.estimatedCostPerAcre,
    notes: fields.notes,
    chemicals: fields.chemicals?.map(toChemicalTemplateItemRequest),
  });
}

function toChemicalTemplateItemRequest(item: ChemicalTemplateItemRequest): ChemicalTemplateItemRequest {
  return omitUndefined<ChemicalTemplateItemRequest>({
    chemicalId: item.chemicalId,
    customChemicalId: item.customChemicalId,
    name: item.name,
    epaNumber: item.epaNumber,
    rate: item.rate,
    rateValue: item.rateValue,
    rateUnit: item.rateUnit,
    ratePerUnit: item.ratePerUnit,
    purpose: item.purpose,
  });
}
